import i18n from 'services/base/i18n';

export default {
  title: (family: string, domain: string, device: string) => i18n.sprintf(
    i18n.pgettext('Issues|Malware Domain', 'Blocked %1$s server (%2$s) for %3$s.'),
    family, domain, device,
  ),

  description: (family: string, domain: string, device: string) => i18n.sprintf(
    i18n.pgettext('Issues|Malware Domain', 'Traffic to/from a listed %1$s malware server (%2$s) has been blocked by Pangolin from communicating with %3$s'),
    family, domain, device,
  ),

  kindTitle:        () => i18n.pgettext('Issues|Malware Domain|Kind', 'Malware Domain Access'),
  kindSubtitle:     () => i18n.pgettext('Issues|Malware Domain|Kind', 'Malware Servers / Spread Vectors'),

  actionValueAllow: () => i18n.pgettext('Issues|Malware Domain|Action', 'Allow'),
  actionValueBlock: () => i18n.pgettext('Issues|Malware Domain|Action', 'Block'),

  actionLabelAllow: () => i18n.pgettext('Issues|Malware Domain|Action', 'Allow traffic between host and domain'),
  actionLabelBlock: () => i18n.pgettext('Issues|Malware Domain|Action', 'Block traffic between host and domain'),
};
